import React from 'react';
import { useTranslation } from 'react-i18next';
import FilterButtons from 'components/FilterButtons';
import { statusFilterButtons } from 'types/content';
function StatusFilter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FilterButtons, {
    label: t('property_status_colon'),
    queryParam: "status",
    options: statusFilterButtons,
    defaultOption: "all"
  });
}
export default StatusFilter;